/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { setSelected } from "./reportDetailSlice";
import { useHistory } from "react-router-dom";
import { formatDate, sizePerPageList } from "../../../utility";

export const ReportDetailTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const showDetail = (e, column) => {
    dispatch(setSelected(column));
    history.push("/report-return/report-detail/detail");
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, column) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={(e) =>
                history.push(
                  `/report-return/report-detail/detail/${column.returnd_id}`
                )
              }
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          </OverlayTrigger>
        </div>
      ),
    },

    {
      text: "APL Return Number ",
      dataField: "ret_number",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RTV Num",
      dataField: "rtv_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Sales Office",
      dataField: "sales_office",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Plant Code",
      dataField: "plant_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Plant Name",
      dataField: "plant_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Code",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Name",
      dataField: "customer_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Number",
      dataField: "invoice_ref_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Line Number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "SAP Sales Order",
      dataField: "soNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "SAP Inv Return",
      dataField: "invoiceReturnNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Return Reason",
      dataField: "reason_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Create Date Time",
      dataField: "created_date",
      sort: true,
      formatter: dateFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Code",
      dataField: "client_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Material Code",
      dataField: "material_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Material Description",
      dataField: "material_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Customer Group 3",
      dataField: "customer_group3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "PH3",
      dataField: "PH3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Requested Quantity",
      dataField: "base_return_qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "UoM",
      dataField: "return_uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "exp_date",
      sort: true,
      formatter: dateFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Type Prod",
      dataField: "type_prod",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   text: "Type Prod",
    //   dataField: "Temp",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      // wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center"
      bootstrap4
      bordered={false}
      keyField="returnd_id"
      data={tableData}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
      hover
    >
      <PleaseWaitMessage entities={loading ? null : tableData} />
      <NoRecordsFoundMessage entities={loading ? null : tableData} />
    </BootstrapTable>
  );
};
